import axiosClient from "api/axiosClient";
import axiosOpenClient from "api/axiosOpenClient";
import { ResumeScoreRequestBody } from "lib/resume-scoring/request-body/request-body-types";

export const analyseResume = async (resume: ResumeScoreRequestBody) => {
  // try {
  //   const response = await axiosOpenClient.post(
  //     "/api/resumes/analyse",
  //     resume
  //   );
  //   // console.log("response...", response);
  //   return await response.data;
  // } catch (error) {
  //   return null;
  //   console.log(error);
  // }
  const response = await axiosClient.post(
    "/api/resumes/analyse",
    resume
  );
  return await response;
};
